@file:Suppress("TooGenericExceptionThrown")

package com.klantenstop.web.data.repos

import com.klantenstop.web.data.NetworkingConfig
import com.klantenstop.web.data.models.NetworkResponse
import com.klantenstop.web.data.models.dto.requests.address.ValidateAddressDto
import com.klantenstop.web.data.models.dto.requests.address.ValidateCityDto
import com.klantenstop.web.data.models.dto.responses.AddressValidationDto
import com.klantenstop.web.data.models.dto.responses.ErrorResponse
import com.klantenstop.web.data.postRequest

object AddressRepo {
    private val addressUrl = "${NetworkingConfig.baseUrl}/api/v1/addresses"

    suspend fun validateAddress(validateAddress: ValidateAddressDto): AddressValidationDto? {
        val response: NetworkResponse<AddressValidationDto, ErrorResponse> = 
            postRequest("$addressUrl/validate", validateAddress)

        return when (response) {
            is NetworkResponse.Success -> response.body
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: "Server fout bij het valideren van adres"
                throw Exception(errorMessage)
            }
            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het valideren van adres")
        }
    }

    suspend fun validateCity(validateCity: ValidateCityDto): AddressValidationDto? {
        val response: NetworkResponse<AddressValidationDto, ErrorResponse> =
            postRequest("$addressUrl/validate-city", validateCity)

        return when (response) {
            is NetworkResponse.Success -> response.body
            is NetworkResponse.ServerError -> {
                val errorMessage = response.body?.errorDescription ?: "Server fout bij het valideren van stad"
                throw Exception(errorMessage)
            }
            is NetworkResponse.NetworkError -> throw Exception("Netwerkfout: controleer je internetverbinding")
            is NetworkResponse.UnknownError -> throw Exception("Onbekende fout bij het valideren van stad")
        }
    }
}
